<section>

    <app-navbar></app-navbar>


    <body>
        <div class="container pt-4">
            <div class="row">
                <div class="jumbotron jumbotron-fluid col pt-4">
                    <div class="container">
                      <h1 class="display-4 text-center">Contactanos</h1>
                      <h3 class="text-center">Telefono</h3>
                      <p class="lead text-center">(505) 2523 0530</p>
                      <h3 class="text-center">Dirección</h3>
                      <p class="lead text-center">De la cuatro esquina de Monimbó 500mtr al sur, Masaya</p>
                    </div>
                </div>
                <div class="jumbotron jumbotron-fluid col ">
                    <div class="container">
                      <h1 class="display-4 text-center">Ubicación</h1>
                      <div class="lead">
                          <!-- <img src="assets/Image/Img/map.jpeg" class="w-100" alt="Mapa del centro"> -->
                          <google-map [center]="center" [zoom]="zoom"></google-map>
                      </div>             
                    </div>
                </div>
            </div>
        </div>
    </body>

    <app-foot></app-foot>
</section>